export default (function (baseTheme) {
  return {
    height: 'initial',
    wordBreak: 'initial',
    cursor: 'initial',
    resize: 'initial',

    zIndex: 0,
    width: '100%',
    margin: '0 0 0.75rem',
    padding: '0.45em 0.75em',
    border: '1px solid ' + baseTheme.colors.gray[5],
    borderRadius: baseTheme.borderRadius,

    verticalAlign: 'middle',
    fontFamily: baseTheme.fontFamily,
    fontSize: '0.86667rem',

    background: baseTheme.colors.white,
    color: baseTheme.colors.gray[1],
    outline: 'none',

    transition: 'border-color 0.2s ease',

    '&:hover': {
      borderColor: '#256298'
    },

    '&:focus': {
      outline: '5px auto -webkit-focus-ring-color',
      outlineOffset: '-1px'
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-textarea/es/TextareaTheme.js
// module id = 1121
// module chunks = 1